import PermissionCheck from '@Components/Utility/PermissionCheck'
import { PERMISSIONS } from '@Const/permissions'
import Navigation from '@App/navigation'
import RightsholderRegistrationHistoryLayout from '@Scenes/RightsholderScene/RightsholderCatalogRegistrationHistory/RightsholderRegistrationHistoryLayout'
import { RIGHTSHOLDER_SUB_ROUTES } from '@App/navigation/route'
import RightsholderCatalogRegistrationHistory from '@Scenes/RightsholderScene/RightsholderCatalogRegistrationHistory'
import ViewWorkInternalScene from '@Scenes/WorkScenes/ViewWorkInternalScene'
import ReviewWorkFormScene from '@Scenes/WorkScenes/ReviewWorkFormScene'
import { FetchType } from '@Components/WorkItemV2/fetch-type-enum'
import React from 'react'

export const createRegistrationHistoryRoutes = () => ({
    path: '',
    element: (
        <PermissionCheck
            requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status]}
            orIsInternal
            reRouteLocation={Navigation.home.root()}
        >
            <RightsholderRegistrationHistoryLayout />
        </PermissionCheck>
    ),
    children: [
        {
            path: RIGHTSHOLDER_SUB_ROUTES.registrationHistory.root,
            element: <RightsholderCatalogRegistrationHistory />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.registrationHistory.resubmit,
            element: <ReviewWorkFormScene workType="draft" showHeader />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.catalog.viewWork,
            element: <ViewWorkInternalScene fetchType={FetchType.HFA} />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.registrationHistory.submission,
            element: <ViewWorkInternalScene fetchType={FetchType.MLC} />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.registrationHistory.transaction,
            element: <ViewWorkInternalScene fetchType={FetchType.TRANSACTION} />,
        },
    ],
})
